import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { H1 } from 'UIComponents/elements/headings';
import MainSection from 'ecosystem-marketplace-core/components/layout/MainSection';
import MainSectionInner from 'ecosystem-marketplace-core/components/layout/MainSectionInner'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import CoreStorefrontHeader from 'ecosystem-marketplace-core/components/storefront/StorefrontHeader'; // @ts-expect-error untyped dependency

import { useEmbedContext } from '../hooks/useEmbedContext';
import { getAssetProviderSignupUrl, getTemplatesHomePageRoute } from '../utils/urls';
import { getIsPublicApp } from '../selectors/app';
import { getDownloadedAssetsUrl } from 'ecosystem-marketplace-core/assets/utils/urls'; // @ts-expect-error untyped dependency

import { getIsCustomer } from '../selectors/auth'; // @ts-expect-error untyped dependency

import StorefrontSearchBar from '../components/storefront/search/StorefrontSearchBar';
import { useOfferingType } from '../context/OfferingTypeContext';
const HEADER_CUSTOM_STYLE = {
  MAIN_SECTION_CLASSNAME: 'p-top-7',
  BACKGROUND_COLOR: '#850D63',
  GRADIENT_ANGLE: '223.23deg',
  START_GRADIENT_COLOR: '#850D63',
  END_GRADIENT_COLOR: '#5C62D6'
};
export function StorefrontPage({
  children,
  navigation,
  sidebar
}) {
  const {
    isEmbedded
  } = useEmbedContext();
  const location = useLocation();
  const {
    pathname: currentPathname
  } = location;
  const [isSticky, setIsSticky] = useState(false);
  const onStickyChange = useCallback(evt => {
    setIsSticky(evt.target.value);
  }, []);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(CoreStorefrontHeader, {
      collapsedTitle: /*#__PURE__*/_jsx(UIRouterLink, {
        to: getTemplatesHomePageRoute(),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.header.collapsedTitle"
        })
      }),
      compact: isEmbedded,
      customStyle: HEADER_CUSTOM_STYLE,
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.header.subtitle"
      }),
      testId: "storefront-header",
      title: /*#__PURE__*/_jsx(UIRouterLink, {
        to: getTemplatesHomePageRoute(),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(HeadingComponent, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.header.title"
          })
        })
      }),
      renderedButtonRow: /*#__PURE__*/_jsx(HeaderButtonRow, {}),
      onStickyChange: onStickyChange,
      children: /*#__PURE__*/_jsx(StorefrontSearchBar, {
        isSticky: isSticky
      })
    }, `storefront-header-${currentPathname}`), navigation, /*#__PURE__*/_jsx(MainSection, {
      responsive: true,
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        children: /*#__PURE__*/_jsxs(UIGrid, {
          children: [sidebar, children]
        })
      })
    })]
  });
}

function HeadingComponent(props) {
  const {
    pathname
  } = useLocation();

  if (pathname === '/') {
    return /*#__PURE__*/_jsx(H1, Object.assign({}, props, {
      "aria-level": 1
    }));
  }

  return /*#__PURE__*/_jsx("span", Object.assign({}, props, {
    className: "is--heading-1"
  }));
}

function HeaderButtonRow() {
  const offeringType = useOfferingType();
  const isPublicApp = useSelector(getIsPublicApp);
  const isCustomer = useSelector(getIsCustomer);
  if (isPublicApp) return null;
  return /*#__PURE__*/_jsxs(UIButtonWrapper, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      "data-selenium-id": "manage-apps-button",
      href: getDownloadedAssetsUrl(!isCustomer, offeringType),
      size: "extra-small",
      use: "primary-white",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.header.buttons.manage"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      external: true,
      href: getAssetProviderSignupUrl(),
      iconProps: {
        className: 'hidden'
      },
      size: "extra-small",
      use: "primary-white",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.header.buttons.build"
      })
    })]
  });
}